
<template>
    <div class="form-block">

        <div>
            <h2 class="form-block__title mb-3">{{title_form}}</h2>
            <div class="form-block_body">

                <div v-show="crud === 'create'" class="black_block dragdrop text-center">
<!--                    Drag & Drop you photos here <br> or <br>-->
                    <input @change="uploadVideos" type="file" id="uploadfile" multiple class="d-none">
                    <label class="btn btn-upload" for="uploadfile">BROWSE FILES</label>
                </div>
                <div class="upload_group h390">

                    <div v-for="video in videos" :key="`video_${video.id}`" class="black_block mt-3">                        
                                                
                        <div v-if="(video.done)||(video.crud === 'update')" class="d-flex">
                            
                            <div v-show="video.crud === 'create'" class="black_block__title">{{video.id}}{{video.name}}</div>                            
                            <input v-show="video.crud === 'update'" v-model="video.name" type="text" placeholder="Name" class="form-control">
                            
                            <input v-model="video.date" type="datetime-local" placeholder="Date time" class="form-control">
                            
                            <input  v-show="video.crud === 'create'" v-model="video.description" type="text" placeholder="Description" class="form-control">
                            <input v-show="video.crud === 'update'" v-model="video.description" type="text" placeholder="Description" class="form-control">
                            
                            <div class="btn-close"></div>
                        </div>
                        
                        <div v-else class="upload_item">
                            <div class="upload_item__left">
                                <div class="upload_item__left_top">
                                    <span>{{video.name}}</span>
                                    <span>{{video.progress}}%</span>
                                </div>
                                <div class="progress">
                                    <div class="progress-bar" role="progressbar" :style="`width: ${video.progress}%`" :aria-valuenow="video.progress" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                            <div class="upload_item__right">
                                <div class="btn-close"></div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>

        <div class="form-block__footer d-flex justify-content-between">

            <div class="form-block__footer_left d-flex justify-content-start align-items-end">

            </div>
            <div class="form-block__footer_right d-flex justify-content-end align-items-end">
                <button @click="closePopup" class="btn btn-link">Cancel</button>
                <button @click="sendVideos" class="btn btn-primary">Done</button>
            </div>

        </div>

    </div>
</template>

<script>
import {bus} from '../../bus';
import axios from "axios";
export default {
    props: [
        'prop_titleform',
        'crud',
        'prop_videos'
    ],
    data(){
        return{
            title_form: '',
            model_category: {
                first_name: '',
                last_name: '',
                vector: '',
                face_base64: '',
                email: '',
                website: '',
                info: ''
            },
            step: 1,
            progress: 0,
            videos: [],
            videosNum: 0
        }
    },
    methods: {                
        uploadVideos(e){            
            const videos = e.target.files;            
            for (let i = 0; i < videos.length; i++) {
                let front_id = i+Date.now();                
                this.videos.push({
                    'id': 0,
                    'name': videos[i].name,
                    'progress': 0,
                    'done': false,
                    'description': '',
                    'front_id': front_id,
                    'crud': 'create'
                });
                // Index of the row we just pushed (NOT i+videosNum — that skips
                // every other slot when multi-selecting and progress stays at 0%).
                const rowIndex = this.videos.length - 1;
                this.sendVideo(videos[i], front_id, rowIndex);
                this.videosNum++;
            }
            // Allow re-selecting the same files later
            e.target.value = '';
        },
        sendVideo(file, front_id, id){
            console.log('sendVideo this videos: ', this.videos);

            let formData = new FormData();
            formData.append(`front_id`, front_id);
            formData.append(`bin`, file);
            formData.append(`name`, file.name);
            formData.append(`last_modified`, file.lastModified);
            formData.append(`size`, file.size);
            formData.append(`type`,file.type);
            axios.post( 
                '/videos',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    onUploadProgress: (progressEvent) => {
                        const row = this.videos[id];
                        if (!row) return;
                        let progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                        // Vue 2: ensure reactivity for progress updates
                        this.$set(row, 'progress', progress);
                        if(progress === 100){
                            this.$set(row, 'done', true);
                            this.$set(row, 'crud', 'update');
                        }
                    }
                }
            ).then((responce)=>{
                console.log(responce);
                const row = this.videos[id];
                if(row && responce.data.front_id){
                    this.$set(row, 'id', responce.data.id);
                    this.$set(row, 'date', hVue.convertTimestamp(responce.data.date));
                }
            }).catch(function(err){
                // console.log('FAILURE!!');
                console.log(err);
            });
        },        
        sendVideos(){
            for (let i = 0; i < this.videos.length; i++) {
                this.updateVideo(this.videos[i]);
            }
            bus.$emit('openpopup', {
                open: false
            });
            bus.$emit('getvideos', true);
        },
        updateVideo(video){            
            let data = {...video};
            const id = video.id;
            delete data.id;
            // Strip UI-only fields; never send null description (MySQL NOT NULL).
            delete data.progress;
            delete data.done;
            delete data.crud;
            delete data.front_id;
            if (data.description == null) {
                data.description = '';
            }

            console.log('data for update: ', data);

            axios.put( `/videos/${id}`,
                data,
                {headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}}
            ).then((response)=>{

                console.log( 'response.data from update video: ', response.data );

                bus.$emit('getvideos', true);
            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        addVideosForEdit(){
            console.log('addVideosForEdit');
            if( this.crud === 'update' ){                
                this.videos = this.prop_videos.map((video)=>{                    
                    video.date = hVue.convertTimestamp(video.date);
                    return video;
                });
            }
            console.log('addVideosForEdit this videos: ', this.videos);
        },
        closePopup(){
            bus.$emit('getvideos', true);
            bus.$emit('openpopup' , {
                open: false
            });
        }        
    },
    mounted(){
        console.log('this.prop_videos from mounted: ', this.prop_videos);
        this.title_form = this.prop_titleform;
        this.addVideosForEdit();
    }
}
</script>

<style scoped lang="scss">
    .btn-close{
        margin-left: 1rem;
    }
    .colors_block{
        background: var(--color-dark70);
        padding: 1rem;
        display: flex;
        .color_radio{
            cursor: pointer;
            margin: 0 0.5rem;
        }
    }
</style>
